import React from 'react';
import Header from '@gerenciatd/next.components.header-r';
import Footer from '@gerenciatd/next.components.footer-n';
import { wrapper } from '@/store';
import { END } from 'redux-saga';
import { actions as headerActions } from '@gerenciatd/next.app-controller.reducers-sagas.header-reducer-r';
import ErrorScreen, {
  KINDS,
} from '@gerenciatd/next.app-controller.error-screen';

const mainSetup = require('@/config/mainSetup');

const E500 = () => {
  return (
    <>
      <Header next />
      <ErrorScreen kind={KINDS.E500} />
      <Footer />
    </>
  );
};

export const getStaticProps = wrapper.getStaticProps(
  async ({ store, params }) => {
    store.dispatch(
      headerActions.getHeaderInfo({
        pathname: mainSetup.headerFooterPathOnError,
      })
    );
    store.dispatch(
      headerActions.getFooterInfo({
        pathname: mainSetup.headerFooterPathOnError,
      })
    );
    store.dispatch(END);
    await store.sagaTask.toPromise();
    return {};
  }
);

export default E500;
